import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csoperator(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Operator tutorial For Beginners</title>
 <meta name="description" content="C# Operator tutorial for beginners.Operators in c# are used special symbols which perform any type of operations.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Operator,c# Operator for,c sharp Operator,Operator in Csharp(C#) Examples" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-operator" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">CSharp(C#) operator</h1>
    <div className="first">
        <a href="/csharp-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-datatypes">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">An Operator in CSharp</h2>
    <p className="mt-4 para">Operators in c# are used special symbols that perform any type of operation.<br/>
or<br/>
The c# operator is a special symbol which is used in the expression. 
</p>


<h2 className='head3'>An operator in c# Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
          <span className="qwerty-4">Example-</span>
            <span className="qwerty-6">106</span>
            <span className="qwerty-3"> / </span>
            <span className="qwerty-6">8</span>
            <span className="qwerty-3"> % </span>
            <span className="qwerty-6">40</span>
             {"\n"}{"\n"}
             <span className="qwerty-1">Ans- </span>
             <span className="qwerty-2">(</span>
            <span className="qwerty-5">+ </span>
            <span className="qwerty-2">- /</span>
            <span className="qwerty-5"> %</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-8"> this is an </span>
            <span className="qwerty-4">operator</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='headings'>The Operator in c# Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-6">int </span>
            <span className="qwerty-7">c </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-7"> a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-10">so</span>
            {"\n"}
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">, </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-10">are an </span>
            <span className="qwerty-5">operands</span>
            {"\n"}
            <span className="qwerty-7">a</span>
            <span className="qwerty-5">, </span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-10">is an </span>
            <span className="qwerty-5">operand</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='headings'>The Operator in c# Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-7">A </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">+</span>
            <span className="qwerty-7"> c</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-7">d</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5"> Above in this line of code</span>
            {"\n"}
            <span className="qwerty-3">= </span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-10"> are operators means there are </span>
            <span className="qwerty-5">2 operators</span>
            {"\n"}
            <span className="qwerty-7">B</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-7">d</span>
            <span className="qwerty-10"> are operands means there are</span>
            <span className="qwerty-5"> 3 operands</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='head3'>The Operator in c# Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-7">A </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">+</span>
            <span className="qwerty-7"> c</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-7">d</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5"> Above in this line of code</span>
            {"\n"}
            <span className="qwerty-3">= </span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-10"> are operators means there are </span>
            <span className="qwerty-5">2 operators</span>
            {"\n"}
            <span className="qwerty-7">B</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-7">d</span>
            <span className="qwerty-10"> are operands means there are</span>
            <span className="qwerty-5"> 3 operands</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">1, arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>
<h2 className="mt-4 mh2">Csharp Operator Example</h2>


<h2 className="headings">Q-Write a Program and addition no in c# Operator Example code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-4">;</span>
            {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">8</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-7">c</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">Console</span>
                <span className="qwerty-7">.WriteLine</span>
              <span className="qwerty-3">(</span>
              <span className="qwerty-4">c</span>
              <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">12 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='headings'>The Operator in c# Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-7">C </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> - </span>
            <span className="qwerty-2">b </span>
            {"\n"}
            <span className="qwerty-7">C </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-2">b </span>
            {"\n"}
            <span className="qwerty-7">C </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> / </span>
            <span className="qwerty-2">b </span>
            {"\n"}
            <span className="qwerty-7">C </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> % </span>
            <span className="qwerty-2">b </span>
            {"\n"}
            <span className="qwerty-7">C</span>
            <span className="qwerty-3"> =</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> ++</span>
            <span className="qwerty-1"> ; </span>
            <span className="qwerty-3">or</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> --</span>
            <span className="qwerty-1"> ; </span>
            {"\n"}
            <span className="qwerty-7">C</span>
            <span className="qwerty-3"> =</span>
            <span className="qwerty-2"> b</span>
            <span className="qwerty-3"> ++</span>
            <span className="qwerty-1"> ; </span>
            <span className="qwerty-3">or</span>
            <span className="qwerty-2"> b</span>
            <span className="qwerty-3"> --</span>
            <span className="qwerty-1"> ; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">2,Relational operator:</h2>
<h3 className="mt-4 mh3"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>

<h4 className="mt-4">c# Relational Operator Example</h4>



<h2 className="headings">Q-Write a Program and check Greater no C# Operator Example code?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty">.WriteLine </span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-5">b </span>
            <span className="qwerty-6">is </span>
            <span className="qwerty-7">greater</span>
            <span className="qwerty-3">");</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5">b </span>
            <span className="qwerty-6">is </span>
            <span className="qwerty-7">greater</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a Program and check both value equal or not in C# Operator Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">int </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-6">,</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-6">;</span>
            {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty">&#60;</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty">.WriteLine</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">both </span>
            <span className="qwerty-6">equal</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">both </span>
            <span className="qwerty-6">equal</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">3,Logic operator:</h2>
<h3 className="mt-4 mh3">And  &#38;&#38;<br/>
Or   &#124;&#124;<br/>
Not &#33;
</h3>



<h2 className="headings">Q-Write a Program and check True or False in C# Operator Example ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">int </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-6">,</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-6">,</span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-6">;</span>
            {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">c </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">40</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty">.WriteLine</span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-4">&#60; = </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3"> && </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-4">&#62; </span>
            <span className="qwerty-7">c</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">false </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">4,Bitwise operator:</h2>
<h3 className="mt-4 mh3">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>

<h2 className="mt-4 mh2">6, Identifier operator in c#:</h2>


<h2 className="headings">Q-Write a Program and Multiple no in C# Operator Example ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">5</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-5">Console</span>
              <span className="qwerty-4">.WriteLine </span>
              <span className="qwerty">(</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}
            <span className="qwerty-7">a</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">Console</span>
              <span className="qwerty-4">.WriteLine </span>
              <span className="qwerty">(</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">5</span>
              {"\n"}
              <span className="qwerty-6">20</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">7, The conditional operator (? :) in Csharp:-
</h2>
<p className="mt-4 para">A conditional operator is known as a <span className="bold"> ternary operator.</span><br/>
The main point is that this Conditional operator  consists of three operands.<br/>
</p>



<h2 className="headings">C# Conditional Operator Syntax code:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-6">Variable</span>
            <span className="qwerty-5"> a </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">expression</span>
            <span className="qwerty-2">) </span>
            <span className="qwerty-5">? </span>
            <span className="qwerty">true </span>
            <span className="qwerty-2">:</span>
            <span className="qwerty-5"> false</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">8,Unary operator:</h2>
<h3 className="mt-4 mh3">++<br/>
--
</h3>


<h2 className="headings">Q-Write a Program and check C# Unary Operator Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-5">Console.</span>
              <span className="qwerty-4">WriteLine</span>
              <span className="qwerty">(</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">)</span>
              <span className="qwerty-4">;</span>
              {"\n"}
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">++</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">Console.</span>
              <span className="qwerty-4">WriteLine</span>
              <span className="qwerty">(</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">)</span>
              <span className="qwerty-4">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">10</span>
              {"\n"}
              <span className="qwerty-6">11</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



 

<h2 className="headings">Q-If you add more no inside unary c# operator?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">; </span>
            {"\n"}
              <span className="qwerty-5">Console</span>
              <span className="qwerty-6">.WriteLine</span>
              <span className="qwerty-3">(</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}{"\n"}
              <span className="qwerty-1">OR</span>
              {"\n"} {"\n"}
              <span className="qwerty">Error</span>
            <span className="qwerty-3">: </span>
              {"\n"}
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">++++</span>
              {"\n"}
              <span className="qwerty-5">Console</span>
              <span className="qwerty-6">.WriteLine</span>
              <span className="qwerty-3">(</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">22</span>
              {"\n"}
              <span className="qwerty-6">error</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Change position of the unary operator?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">If we use </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">)</span>
            {"\n"} {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">);</span>
            {"\n"}
            <span className="qwerty-7">b</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">);</span>
            {"\n"} {"\n"}
            <span className="qwerty-3">If we use  </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-4">)</span>
            {"\n"}{"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">);</span>
            {"\n"}
            <span className="qwerty-7">b</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">20</span>
            {"\n"}
            <span className="qwerty-6">21</span>
            {"\n"}{"\n"}
            <span className="qwerty-6">20</span>
            {"\n"}
            <span className="qwerty-6">20</span>
            {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/csharp-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-datatypes">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)
}
export default Csoperator;